// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addEditPriceList-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0;
  align-self: stretch;

  .content-ele {
    width: 385px;
    flex-direction: column;
    align-items: flex-start;
    gap: var(--spacing-spacing-4, 4px);
  }

  .react-select-5-placeholder {
    color: var(--text-contrast, #34383F);
    font-family: 'Avenir';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
}

.add-price-matrix {

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
}

.ReimbursementTable {

  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */

  &::-webkit-scrollbar {
    display: none;
  }

  tr {
    background-color: #FFFFFF;
  }

  th,
  td {
    min-width: 150px;

    &.dd {
      min-width: 250px;
    }
  }

  th:last-child, td:last-child {
    min-width: 100px;
  }

  thead > tr > th:nth-child(7) {
    border-left: 2px solid #fff;
  }

  th {
    white-space: nowrap;
  }

  .table-header {
    height: 56px;
    color: #002466;
    font-family: 'Avenir', sans-serif;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    background-color: #E3ECF9;
  }

  .table-header th {
    border-bottom: 2px solid #fff;
  }

  .table-header th:first-child{
    border-right: 1px solid #E2E3E5;
    min-width: 150px;
    left: 0;
    position: sticky;
    background-color: inherit;
    z-index: 1;
  }

  .table-header th:last-child{
    border-left: 1px solid #E2E3E5;
    min-width: 100px;
    right: 0;
    position: sticky;
    background-color: inherit;
    z-index: 1;
  }

  .sub-header {
    background-color: #EDF5FF;
    text-align: center;
  }

  .table-row {
    height: 52px;
    width: fit-content;
    color: #34383F;

    &:hover {
      background-color: #F8F9FA;
    }
  }

  .fixed {
    position: sticky;
    background-color: inherit;
    z-index: 1;
  }

  .fixed.left {
    min-width: 150px;
    left: 0;
  }

  .fixed.right {
    min-width: 50px !important;
    right: 0;
  }

  .last-updated-width {
    min-width: 200px !important;
  }

  .min-w-action {
    width: 100px !important;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
}
.price-derivation-table {
  border-top: solid 1px #ccc;
}`, "",{"version":3,"sources":["webpack://./src/pages/pricing/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,SAAW;EACX,mBAAmB;;EAEnB;IACE,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,kCAAkC;EACpC;;EAEA;IACE,oCAAoC;IACpC,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;;EAEE,gCAAgC;EAChC;;IAEE,wBAAwB;IACxB,SAAS;EACX;;EAEA,YAAY;EACZ;IACE,0BAA0B;EAC5B;AACF;;AAEA;;EAEE,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;;EAEZ;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;;IAEE,gBAAgB;;IAEhB;MACE,gBAAgB;IAClB;EACF;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,cAAc;IACd,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;EAC3B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,+BAA+B;IAC/B,gBAAgB;IAChB,OAAO;IACP,gBAAgB;IAChB,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,QAAQ;IACR,gBAAgB;IAChB,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,cAAc;;IAEd;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,gBAAgB;IAChB,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,OAAO;EACT;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,uBAAuB;EACzB;;EAEA,gCAAgC;EAChC;;IAEE,wBAAwB;IACxB,SAAS;EACX;;EAEA,YAAY;EACZ;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,0BAA0B;AAC5B","sourcesContent":[".addEditPriceList-content {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 16px;\n  flex: 1 0 0;\n  align-self: stretch;\n\n  .content-ele {\n    width: 385px;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--spacing-spacing-4, 4px);\n  }\n\n  .react-select-5-placeholder {\n    color: var(--text-contrast, #34383F);\n    font-family: 'Avenir';\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 20px;\n  }\n}\n\n.add-price-matrix {\n\n  /* Chrome, Safari, Edge, Opera */\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  /* Firefox */\n  input[type=number] {\n    -moz-appearance: textfield;\n  }\n}\n\n.ReimbursementTable {\n\n  -ms-overflow-style: none;\n  /* IE and Edge */\n  scrollbar-width: none;\n  /* Firefox */\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n\n  tr {\n    background-color: #FFFFFF;\n  }\n\n  th,\n  td {\n    min-width: 150px;\n\n    &.dd {\n      min-width: 250px;\n    }\n  }\n\n  th:last-child, td:last-child {\n    min-width: 100px;\n  }\n\n  thead > tr > th:nth-child(7) {\n    border-left: 2px solid #fff;\n  }\n\n  th {\n    white-space: nowrap;\n  }\n\n  .table-header {\n    height: 56px;\n    color: #002466;\n    font-family: 'Avenir', sans-serif;\n    font-size: 14px;\n    font-weight: 700;\n    line-height: 20px;\n    background-color: #E3ECF9;\n  }\n\n  .table-header th {\n    border-bottom: 2px solid #fff;\n  }\n\n  .table-header th:first-child{\n    border-right: 1px solid #E2E3E5;\n    min-width: 150px;\n    left: 0;\n    position: sticky;\n    background-color: inherit;\n    z-index: 1;\n  }\n\n  .table-header th:last-child{\n    border-left: 1px solid #E2E3E5;\n    min-width: 100px;\n    right: 0;\n    position: sticky;\n    background-color: inherit;\n    z-index: 1;\n  }\n\n  .sub-header {\n    background-color: #EDF5FF;\n    text-align: center;\n  }\n\n  .table-row {\n    height: 52px;\n    width: fit-content;\n    color: #34383F;\n\n    &:hover {\n      background-color: #F8F9FA;\n    }\n  }\n\n  .fixed {\n    position: sticky;\n    background-color: inherit;\n    z-index: 1;\n  }\n\n  .fixed.left {\n    min-width: 150px;\n    left: 0;\n  }\n\n  .fixed.right {\n    min-width: 50px !important;\n    right: 0;\n  }\n\n  .last-updated-width {\n    min-width: 200px !important;\n  }\n\n  .min-w-action {\n    width: 100px !important;\n  }\n\n  /* Chrome, Safari, Edge, Opera */\n  input::-webkit-outer-spin-button,\n  input::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  /* Firefox */\n  input[type=number] {\n    -moz-appearance: textfield;\n  }\n}\n.price-derivation-table {\n  border-top: solid 1px #ccc;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
